module.exports = __webpack_public_path__ + "files/5f96faf2a9e490307cbeeeed2ecd93a6.svg";